module.exports = __webpack_public_path__ + "static/Rosewater5-d88c67ff4296c52080aff481577fc6b9.webp";